import { Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { BlankTitleInsurance } from '../../chicago.component';
import { SnackbarService } from 'src/app/shared/services/ui/snackbar.service';
import { ChicagoStatus } from '@core/util/chicago';
import { MatDialog } from '@angular/material/dialog';
import {
	ChicagoPortalComponent,
	ChicagoPortalData,
} from '../../chicago-portal/chicago-portal.component';
import { TestHooks } from './under-review.hooks';
import { ChicagoFunctions } from 'src/app/shared/functions/chicago.service';
import { firstValueFrom } from 'rxjs';

@Component({
	selector: 'app-chicago-under-review',
	templateUrl: './under-review.component.html',
	styleUrls: ['./under-review.component.scss'],
	standalone: false,
})
export class ChicagoUnderReviewComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	public blankTitleInsurance = BlankTitleInsurance;
	public loading = false;
	public chicagoStatus = ChicagoStatus;
	@Input() matterId: string;
	@Input() thirdPartyId: number;
	@Input() status: ChicagoStatus;

	constructor(
		private chicagoFunctions: ChicagoFunctions,
		private snackbarService: SnackbarService,
		private dialog: MatDialog,
	) {}

	async checkStatus(): Promise<void> {
		this.loading = true;
		const { matterId, thirdPartyId } = this;
		if (matterId && thirdPartyId) {
			await firstValueFrom(
				this.chicagoFunctions.getAllStatusDetails(thirdPartyId, matterId),
			);
			this.snackbarService.openSnackBar(
				{ text: 'Order status has been updated.', type: 'info' },
				{
					duration: 3000,
					panelClass: 'ml-96',
				},
			);
		}

		this.loading = false;
	}

	openPortal() {
		const data: ChicagoPortalData = {
			submitNewOrder: false,
		};

		this.dialog.open(ChicagoPortalComponent, { data });
	}
}
